import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import "./index.css";
import parser from "html-react-parser";

function AngelAiLP({angelAiLink}) {
    const imgCDNURL = process.env.REACT_APP_CDN_URL + "eaimortgage/images/";
    return (
        <section className="AngelAiLP-section">
            <Container className="AngelAiLP-container">
                <Row className="AngelAiLP-row">
                    <Col lg={7} md={12} sm={12} className="AngelAiLP-column">
                        <div className="AngelAiLP-content">
                            <h2 className="AngelAiLP-heading">The mortgage process<br /> shouldn't be stressful!</h2>
                            <p className="AngelAiLP-para">
                                Connect with your EvolutionAi loan officer and {parser(angelAiLink)} today, and they can help you choose the best loan program for you and your family!
                            </p>
                        </div>
                    </Col>
                    <Col lg={5} md={12} sm={12} className="AngelAiLP-column">
                        <img
                            src={`${imgCDNURL}angelai-bot.gif`}
                            alt="AngelAi"
                            className="AngelAiLP-gif"
                        />
                        <Button variant="warning" className="AngelAiLP-button" onClick={() => window.open("https://askangel.ai/evolution", "_blank")}>LET's CHAT</Button>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default AngelAiLP;